import React from 'react';
import { Typography } from 'antd';
import AppCarousel from 'common/components/carousel.component';
import SvgIcon from 'common/components/svg-icon.component';
import { GeneralTranscription } from 'config/constants/transcription.constant';
import RibbonIcon from 'config/static/svg/ribbon.svg';
import { HomeIsland } from 'store/models/setting.model';
import styles from './style.module.scss';

const { Title, Text } = Typography;

type IslandProps = {
  island: HomeIsland;
  items: React.ReactNode[];
};

const IslandProducts: React.FC<{ island: HomeIsland; items: React.ReactNode[] }> = ({ island, items }) => {
  if (items.length === 0) return null;
  if (island.showCarousel === false) return <div className={styles['products-grid']}>{items}</div>;
  return (
    <div className={styles['carousel-island-container']}>
      <AppCarousel items={items} slidesToScroll={1} slidesToShow={6} infinite={true} />
    </div>
  );
};

/**
 * `bannerImages` y `redirectUrl` llegan en el documento pero de momento no se
 * pintan: el home muestra título, descripción y productos. El banner se retoma
 * cuando se defina el diseño.
 */
const IslandComponent: React.FC<IslandProps> = ({ island, items }) => {
  return (
    <div className={styles['island-section']}>
      <div className={styles['island-header']}>
        {island.headerText && (
          <Text type='secondary' strong className={styles['island-eyebrow']}>
            {island.headerText}
          </Text>
        )}

        <div className={styles['island-title-row']}>
          <Title level={2} className={styles['island-title']}>
            {island.sectionName}
          </Title>

          {island.isFeatured && (
            <div className={styles['island-rule']}>
              <span className={styles['island-rule-line']} />
              <span className={styles['featured-mark']}>
                <SvgIcon source={RibbonIcon} name={GeneralTranscription.FEATURED} height={26} width={26} />
                <span className={styles['featured-label']}>{GeneralTranscription.FEATURED}</span>
              </span>
              <span className={`${styles['island-rule-line']} ${styles['island-rule-line--end']}`} />
            </div>
          )}
        </div>

        {island.description && (
          <Text type='secondary' className={styles['island-description']}>
            {island.description}
          </Text>
        )}
      </div>

      <IslandProducts island={island} items={items} />
    </div>
  );
};

export default IslandComponent;
